var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.044,
    cy: 11.893,
    r: 7.5,
    stroke: "#7A7359",
    strokeLinecap: "round",
    transform: "rotate(45 12.044 11.893)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7A7359",
    strokeLinecap: "round",
    d: "M4.785 12.081a7.5 7.5 0 0 0 7.5-7.5m7.241 7.331a7.5 7.5 0 0 0-7.5 7.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7A7359",
    d: "M17.348 6.589 6.741 17.196m0-10.606 10.607 10.606"
  })));
};
export { SvgActivity as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxjaXJjbGUgY3g9IjEyLjA0NCIgY3k9IjExLjg5MyIgcj0iNy41IiBzdHJva2U9IiM3QTczNTkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTIuMDQ0IDExLjg5MykiLz48cGF0aCBzdHJva2U9IiM3QTczNTkiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZD0iTTQuNzg1IDEyLjA4MWE3LjUgNy41IDAgMCAwIDcuNS03LjVNMTkuNTI2IDExLjkxMmE3LjUgNy41IDAgMCAwLTcuNSA3LjUiLz48cGF0aCBzdHJva2U9IiM3QTczNTkiIGQ9Ik0xNy4zNDggNi41ODkgNi43NDEgMTcuMTk2TTYuNzQxIDYuNTlsMTAuNjA3IDEwLjYwNiIvPjwvc3ZnPg==";